import flatpickr from 'flatpickr';
const Polish = require('flatpickr/dist/l10n/pl.js').default.pl;
const _InputComponentHandler = (function () {
    const locale = window.App.locale ?? 'pl';
    return {
        // Public functions
        init: function () {
            $('input[type="date"], input[type="datetime"]').each(function () {
                let fp = flatpickr(this, {
                    disableMobile: true,
                    allowInput: true,
                    enableTime: $(this).data('with_time') ?? false,
                    locale: locale == 'pl' ? Polish : undefined,
                });
            });
        },
    };
})();
window.InputComponentHandler = _InputComponentHandler;
